import React from 'react';
import { useAuth } from '@/hooks/useAuth';
import { Button } from '@/components/ui/button';
import { Eye, X } from 'lucide-react';

export const ImpersonationBanner: React.FC = () => {
  const { impersonatingUser, stopImpersonating } = useAuth();

  if (!impersonatingUser) return null;

  return (
    <div className="bg-primary text-primary-foreground px-4 py-2 flex items-center justify-center gap-3 text-sm relative z-50">
      <Eye className="w-4 h-4" />
      <span>
        Viewing as <strong>{impersonatingUser}</strong> — permission checks are simulated
      </span>
      <Button
        variant="secondary"
        size="sm"
        onClick={stopImpersonating}
        className="h-6 px-2 text-xs gap-1"
      >
        <X className="w-3 h-3" />
        Exit
      </Button>
    </div>
  );
};
